import * as React from "react";

type DelayedUnmountProps = {
  isMounted: boolean;
  delay?: number;
  children: React.ReactNode;
  onUnmountChildren?: () => void;
};

const DelayedUnmount = ({
  isMounted,
  delay = 300,
  children,
  onUnmountChildren,
}: DelayedUnmountProps) => {
  const [shouldRender, setShouldRender] = React.useState(isMounted);
  const initialRender = React.useRef(true);

  React.useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    if (isMounted) {
      setShouldRender(true);
    } else {
      timeoutId = setTimeout(() => {
        setShouldRender(false);
      }, delay);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isMounted, delay]);

  React.useEffect(() => {
    initialRender.current = false;

    if (!shouldRender && !initialRender.current) {
      onUnmountChildren?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldRender]);

  return shouldRender ? <>{children}</> : null;
};

export { DelayedUnmount, type DelayedUnmountProps };
